import {ChangeDetectorRef} from '@angular/core';

export class LoadingStateHolder {

    private states: string[] = [];

    constructor(states: string[] = [],
                private _cdr: ChangeDetectorRef) {
        this.states = states;
    }

    public start(name: string) {
        setTimeout(() => {
            if (this.states.indexOf(name) === -1) {
                this.states.push(name);
            }

            this._cdr.markForCheck();
        })
    }

    public done(name: string) {
        setTimeout(() => {
            if (this.states.indexOf(name) > -1) {
                this.states.splice(this.states.indexOf(name), 1);
            }

            this._cdr.markForCheck();
        });
    }

    public set(name: string, loading: boolean) {
        if (loading) {
            this.start(name);
        } else {
            this.done(name);
        }
    }

    public isBusy(): boolean {
        return this.states.length > 0;
    }

    public isBusyByStateName(name: string): boolean {
        return this.states.some((state) => state === name);
    }

    public isBusyByStateNames(...names: string[]): boolean {
        return this.states.some((state) =>
            names.some((name) => name === state)
        );
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/providers/loading/loading.service.ts